import { useBizApiClient } from "../_base/useBizApiClient";
import { useSharedStorage } from "../../../sharedStorage/useSharedStorage";
import apiClientOC from "icfrontendapiclient";
const bizApiErrorInterpreter = apiClientOC.get("BizApiErrorInterpreter");
const useComplianceSummaryClient = () => {
  const [cloudAccountId] = useSharedStorage("cac_in_focus_cloud_account_id");
  const formatResult = unformattedResult => {
    if (bizApiErrorInterpreter.isError(unformattedResult)) {
      return unformattedResult;
    }

    // create combined compliance totals
    // this assumes all field names are the same for each compliance (but with different values)
    let combinedSummary = {};
    Object.keys(unformattedResult.summary.compliance_summary).forEach(complianceKey => {
      const curCompliance = unformattedResult.summary.compliance_summary[complianceKey];
      Object.keys(curCompliance).forEach(exceptionTypeKey => {
        if (!combinedSummary?.[exceptionTypeKey]) {
          combinedSummary[exceptionTypeKey] = structuredClone(curCompliance[exceptionTypeKey]);
          return;
        }
        Object.keys(curCompliance[exceptionTypeKey]).forEach(countTypeKey => {
          Object.keys(curCompliance[exceptionTypeKey][countTypeKey]).forEach(countKey => {
            combinedSummary[exceptionTypeKey][countTypeKey][countKey] += curCompliance[exceptionTypeKey][countTypeKey][countKey];
          });
        });
      });
    });
    let newResult = unformattedResult;
    newResult.summary.combined_compliance_summary = combinedSummary;
    return newResult;
  };
  const [sendRequest, result] = useBizApiClient({
    name: `complianceSummary_${cloudAccountId}`,
    method: "get",
    path: `/cloud/assessment/latest/summary?cloud_id=${cloudAccountId}`,
    formatResultFunc: formatResult
  });
  return [sendRequest, result];
};
export { useComplianceSummaryClient };